<div class="bg-white">
    <h2 class="settings-header px-4 pt-5 pb-3 mb-0">{{'billing' | translate}}</h2>

    <div class="px-4 pb-3 pt-3 bg-grey">
        <div class="row py-2 billing-information">
            <div class="col-md-3">
                <h4>{{'billing_information' | translate}}</h4>
            </div>
            <div class="col-md-8 pt-4">
                <p class="pb-2">{{'current_users_quantity' | translate}} {{quantity}} {{'users' | translate}}.</p>
                <p class="pb-2">{{'next_payment' | translate}} {{next_payment}}.</p>
                <p class="recipient-list">{{'next_payment_recipient' | translate}}</p>
                <ul data-cy="recipients-list">
                    @for(recipient of recipients; track recipient){
                    <li>
                        {{recipient}}
                        @if(recipients.length > 1){
                        <span (click)="removeRecipient(recipient)" class="recipient-list-remove">
                            <a>(<i class="far fa-times"></i> {{'remove' | translate}} )</a>
                        </span>
                        }
                    </li>
                    }
                    @if(!isAddingBoxOpened){
                    <li class="recipient-list-add">
                        <a (click)="openAddingBox()" class="recipient-list-add-btn">{{'add_billing_recipient' | translate}} <i class="far fa-inbox-in"></i></a>
                    </li>
                    }
                    @if(isAddingBoxOpened){
                    <li class="recipient-list-add">
                        <form name="recipientAddingBox" class="form-box" [formGroup]="recipientForm" (ngSubmit)="validateRecipientAdding()">
                            <label for="recipientEmail">{{'billing_recipient_email' | translate}}</label><br>
                            <input type="email" name="recipientEmail" id="recipientEmail" [formControl]="emailCtrl">
    
                            <button type="submit" class="btn btn-primary" [disabled]="recipientForm.invalid">{{'validate' | translate}}</button>
                            <button class="btn btn-" (click)="cancelAdding()">{{'cancel' | translate}}</button>
    
                            @if(emailCtrl.dirty && recipientForm.invalid){
                            <p class="email-error">{{'billing_email_error' | translate}}</p>
                            }
                        </form>
                    </li>
                    }
                </ul>
            </div>
        </div>
        @if(invoice_id){
        <hr>
        <div class="row">
            <div class="col-md-3 col-md-offset-1">
                <h4>{{'previous_payments' | translate}}</h4>
            </div>
            <div class="col-md-7">
                <a href="/redirect/invoices/list/{{invoice_id}}" target="_blank"><button class="btn btn-primary btn-sm">{{'view_invoices' | translate}}</button></a>
            </div>
        </div>
        }
        @if(payment_method?.type === 'card'){
        <hr>
        <div class="row pb-2">
            <h4 class="col-md-3">{{'payment_method' | translate}}</h4>
    
            <div class="col-md-8 pt-4">
                <h5>{{'credit_card' | translate}}</h5>
                <p data-cy="credit-card-info">{{payment_method.brand | uppercase}} ****{{payment_method.last4}} {{'credit_card_exp' | translate }} {{payment_method.exp_month}}/{{payment_method.exp_year}}</p>
                <a href="{{credit_card_update_url}}" target="_blank" class="btn btn-primary btn-sm mt-2"><i class="far fa-credit-card"></i> {{'update_credit_card' | translate}}</a>
            </div>
    
        </div>
        }
        <hr>
        <div class="row pb-2">
            <h4 class="col-md-3">{{'account_management' | translate}}</h4>
            <div class="col-md-7 pt-4">
                <a href="mailto:support@teammood.com?subject={{'cancel_my_account' | translate}} ('{{teamId}}')"><button class="btn btn-primary btn-sm">{{'cancel_account' | translate}}</button></a>
            </div>
        </div>
    </div>
    
</div>

